import { useTranslation } from "react-i18next";
import { Grid, Textarea } from "@mantine/core";

import { SelectDeliveryType } from "../SelectDeliveryType";
import { useCreateCampaignInquiryFormContext } from "./formContext";

export interface CreateCampaignInquiryDeliveryFormProps {}
export const CreateCampaignInquiryDeliveryForm = ({}: CreateCampaignInquiryDeliveryFormProps) => {
    const { t } = useTranslation(["common"]);

    const createCampaignInquiryForm = useCreateCampaignInquiryFormContext();

    return (
        <Grid>
            <Grid.Col xs={12} sm={12} md={5}>
                <SelectDeliveryType {...createCampaignInquiryForm.getInputProps("delivery.type")} mb="xs" />
            </Grid.Col>
            <Grid.Col xs={12} sm={12} md={7}>
                <Textarea
                    {...createCampaignInquiryForm.getInputProps("delivery.notes")}
                    mb="xs"
                    label={t("campaign_delivery_note")}
                    placeholder={t("campaign_delivery_note")}
                />
            </Grid.Col>
        </Grid>
    );
};
